<template>
    <div class="campaign-mobile-nav">
        <img v-if="model.logo" :src="model.logo" aria-hidden="true" alt="decorative-drops-icon" />
        <div class="container-fluid mt-0 pt-3" :class="{menuOpen: menuOpen}">
            <div class="d-flex container-fluid justify-content-between align-items-center mt-0">
                <div v-if="model.hsyIcon">
                   <a :href="model.startPageUrl" :aria-label="model.logoText" class="hsy-icon">
                        <img :src="model.hsyIcon" aria-hidden="true" alt="" />
                   </a>
                </div>
                <div class="d-flex" v-if="model.mainNavigation.length > 0">
                    <button class="unstyled-button px-0 ml-1" :aria-label="model.menuButtonLabel" @click="menuOpen = !menuOpen">
                        <svg v-if="!menuOpen" class="icon icon-hsy-icon-menu"><use xlink:href="#icon-hsy-icon-menu"></use></svg>
                        <svg v-if="menuOpen" class="icon icon-hsy-icon-close-bold"><use xlink:href="#icon-hsy-icon-close-bold"></use></svg>
                    </button>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div v-if="menuOpen" class="container-fluid">
                <div class="main-nav mb-4">
                    <ul :aria-label="model.mainNavigationHeading">
                        <li v-for="(navItem, index) in model.mainNavigation" :key="index">
                            <a v-if="navItem.isCurrentPage" :href="navItem.url" aria-current="page">{{ navItem.name }}</a>
                            <a v-else :href="navItem.url">{{ navItem.name }}</a>
                        </li>
                    </ul>
                </div>
                <div>
                    <div class="row pb-5">
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
 
    export default {
        props: {
            model: {
                type: Object,
                required: true
            }
        },
        data: () => {
            return {
                menuOpen: false
            }
        },
        mounted: function () {
            setTimeout(() => {
                this.goToAnchorInUrl();
            }, 500)
        },
        methods: {
            goToAnchorInUrl() {
                if (window.location.hash) {
                    let anchorId = window.location.hash.substring(1);
                    document.getElementById(anchorId).scrollIntoView();
                }
            },
        }
    }
</script>